import React from 'react';
import { Headline } from '@oneaudi/unified-web-components';
import { UeElement } from '@oneaudi/falcon-tools';
import { renderTextWithFootnotesReferencesV2 } from '@oneaudi/feature-app-utils';
import { TextHeadlineContainer } from './EditorialColumns.style';
import { Alignment, HeadingOption } from '../../types';

interface EditorialHeadlineProps {
  headingOption?: HeadingOption;
  testid: string;
  alignment: Alignment;
}

export const EditorialHeadline: React.FC<EditorialHeadlineProps> = ({
  headingOption,
  testid,
  alignment,
}) => {
  if (!headingOption || !headingOption.heading) return null;

  return (
    <TextHeadlineContainer data-testid={testid} alignment={alignment}>
      <Headline
        tag={headingOption.headingTag || 'h2'}
        variant={{ type: 'headline', order: '2', weight: 'normal' }}
        data-testid="numbers-headline"
      >
        <UeElement type="text" property="headingOption_heading" label="Headline">
          {renderTextWithFootnotesReferencesV2(headingOption.heading)}
        </UeElement>
      </Headline>
    </TextHeadlineContainer>
  );
};
